<template>
  <section>
    <h2 v-if="title" class="text-app-primary-1-red--fire-brick text-3xl font-bold mb-8">
      {{ title }}
    </h2>
    <div v-for="(item, index) in items" :key="index">
      <template v-if="item.__typename.includes('_text_')">
        <div class="prose prose--app" v-html="item.description"></div>
      </template>
      <template v-if="item.__typename.includes('_newsletter_')">
        <AtomNewsletter
          :label="item.label"
          :origin="item.origin"
          :endpoint-path="item.newsletterEndpointPath"
          :url="item.url"
          @newsletter-subscribed="$emit('newsletter-subscribed')"
        ></AtomNewsletter>
      </template>
      <template v-if="item.__typename.includes('_buttons_') && item.buttons.length > 0">
        <div class="flex flex-row gap-8 py-4">
          <div v-for="(button, i) in item.buttons" :key="i">
            <MoleculeButton :url="button.url" @click="$emit(button.close ? 'close' : 'hide')">{{ button.label }}</MoleculeButton>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, required: false, default: '' },
  items: { type: Array as PropType<any[]>, required: true },
})

defineEmits(['close', 'hide', 'newsletter-subscribed'])
</script>

<style scoped lang="scss"></style>
